import store from '@/store/index.js';
import analyticsService from '@/services/shared/analyticsService.js';

class BackButtonService {
  getBackButtonConfig (route) {
    var config = {
      displayButton: true,
      displayText: false,
      buttonText: null,
      buttonIcon: 'mdi-keyboard-backspace',
      gtag: this.backGtag
    };

    switch (route.name) {
      case 'signin':
      case 'oboSignin':
      case 'home':
        config.displayButton = false;
        break;
      case 'clientLanding':
        config.buttonIcon = 'mdi-magnify';
        config.buttonText = 'Back to Search';
        config.gtag = this.searchGtag;
        break;
      case 'clientTabs':
        config.buttonIcon = 'mdi-magnify';
        config.gtag = this.searchGtag;
        break;
      case 'clientContacts':
      case 'clientProfiles':
      case 'clientPolicies':
        config.buttonText = 'Back to Client';
        break;
      case 'clientPolicyDetail':
      case 'policyTabs':
        config.buttonText = 'Back to Policies';
        break;
      case 'search':
        config.displayButton = false;
        break;
      default:
        config.buttonText = 'Back';
    }

    return config;
  }

  handleButtonPress (route, router, gtag) {
    var r = null;
    var config = { category: 'Nav', action: 'BackNav', label: 'Navigate Back' };

    switch (route.name) {
      case 'clientLanding':
        config = { category: 'Nav', action: 'BackNav', label: 'Navigate to Search' };
        store.dispatch('setActiveClientTab', 0);
        r = '/search';
        break;
      case 'clientContacts':
      case 'clientProfiles':
      case 'clientPolicies':
        r = `/client/${route.params.clientId}`;
        break;
      case 'clientPolicyDetail':
        store.dispatch('setActivePolicyTab', 0);
        store.dispatch('setActiveClientTab', 3);
        store.dispatch('setActiveVehicleTab', 0);
        r = `/client/${route.params.clientId}`;
        break;
      case 'lobLanding':
        store.dispatch('setActiveLineOfBusinessTab', 0);
        store.dispatch('setActivePolicyTab', 1);

        r = `/client/${route.params.clientId}/policy/${route.params.policyOrderNumber}`;
        break;
      case 'policyVehicle':
      case 'policyDriver':
        store.dispatch('setActiveVehicleTab', 0);
        r = `/client/${route.params.clientId}/policy/${route.params.policyOrderNumber}`;
        break;
      case 'lobVehicles':
      case 'vehicle':
      case 'driver':
        r = `/client/${route.params.clientId}/policy/${route.params.policyOrderNumber}/lob/${route.params.lobId}`;
        break;
      default:
        break;
    }

    if (r != null) {
      analyticsService.sendEvent(gtag, config.action, config.category, config.label);
      router.push(r);
    }
  }
}

var x = new BackButtonService();
export default x;
